export default function Experience() {
  return (
    <>
      <div className="section-header">
        <p className="section-kicker">Experience</p>
        <h2 className="section-title">Where I've been recently</h2>
        <p className="section-description">
          Experience across startups and enterprises, mostly focused on health-tech, automation, and
          front-end heavy applications.
        </p>
      </div>

      <div className="timeline">
        <div className="timeline-item">
          <div className="timeline-badge" />
          <article className="card timeline-card">
            <div className="timeline-title-row">
              <div>
                <div className="timeline-role">Software Engineer</div>
                <div className="timeline-company">ClaimZippy · Health Insurance Tech</div>
              </div>
              <span className="timeline-period">2023 – Present</span>
            </div>
            <ul className="timeline-list">
              <li>
                Developed automated health insurance claim adjudication system using JavaScript and
                Selenium, reducing manual doctor intervention.
              </li>
              <li>Achieved 99% adjudication accuracy in production workflows.</li>
              <li>Built 150+ responsive React screens for critical health-insurance journeys.</li>
              <li>
                Led digitization of 2500+ policy products for ICICI Lombard, converting legacy
                policy data into secure, structured digital formats.
              </li>
            </ul>
          </article>
        </div>

        <div className="timeline-item">
          <div className="timeline-badge" />
          <article className="card timeline-card">
            <div className="timeline-title-row">
              <div>
                <div className="timeline-role">Software Developer</div>
                <div className="timeline-company">Infosys</div>
              </div>
              <span className="timeline-period">2022</span>
            </div>
            <ul className="timeline-list">
              <li>Developed scalable frontend applications for enterprise clients.</li>
              <li>Collaborated with cross-functional teams to ship features on tight timelines.</li>
            </ul>
          </article>
        </div>

        <div className="timeline-item">
          <div className="timeline-badge" />
          <article className="card timeline-card">
            <div className="timeline-title-row">
              <div>
                <div className="timeline-role">Software Developer</div>
                <div className="timeline-company">TechStain Technologies</div>
              </div>
              <span className="timeline-period">2020 – 2022</span>
            </div>
            <ul className="timeline-list">
              <li>Built dynamic websites using React and JavaScript for various client domains.</li>
              <li>Developed the MoSahay job portal, connecting blue-collar workers to jobs.</li>
            </ul>
          </article>
        </div>
      </div>
    </>
  );
}

